module.exports = __webpack_public_path__ + "img/inapp-bg2.105990df.png";